import { get } from 'lodash';

import { isDefined } from 'common';

import {
  DEPRECATED_STATES,
  type ModelLifecycleEntry,
  useModelLifecycleResult,
} from './useModelLifecycle';
import { type ReactFlowBlockNode } from '../../../types';
import { BlockType } from '../../types';

/**
 * Config paths where LlmModelName is stored, keyed by block type.
 * Only block types that use LlmModelName from the flow-api registry are listed.
 */
export const MODEL_NAME_CONFIG_PATHS: Partial<Record<string, string>> = {
  [BlockType.LlmPrompt]: 'config.modelName',
  [BlockType.InformationExtraction]: 'config.modelName',
  [BlockType.HumanTask]: 'config.priorAuthorizationInformation.modelName',
};

export interface BlockWithDeprecatedModel {
  node: ReactFlowBlockNode;
  modelName: string;
  lifecycleEntry: ModelLifecycleEntry;
}

export function useBlocksWithDeprecatedModels(
  blockNodes: ReactFlowBlockNode[]
): BlockWithDeprecatedModel[] {
  const { data } = useModelLifecycleResult();

  if (!isDefined(data)) {
    return [];
  }

  const results: BlockWithDeprecatedModel[] = [];

  for (const node of blockNodes) {
    const configPath = MODEL_NAME_CONFIG_PATHS[node.data.uiBlockType];
    if (!isDefined(configPath)) {
      continue;
    }

    const modelName = get(node.data, configPath) as string | undefined;
    if (!isDefined(modelName)) {
      continue;
    }

    const lifecycleEntry = data.models[modelName];
    if (isDefined(lifecycleEntry) && DEPRECATED_STATES.includes(lifecycleEntry.lifecycleState)) {
      results.push({ node, modelName, lifecycleEntry });
    }
  }

  return results;
}
